//import _ from 'lodash';
import { connect } from 'react-redux';
import {
	getLatestGasBuddyPrices,
	getLatestLockedOutGasBuddyPrices,
	add,
	update,
	bulkAdd,
	getRecentGasBuddyPrices,
} from '../../modules/reports/gasBuddyPrices';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	let latestGasBuddyPrices = undefined;
	let latestIgnoredGasBuddyPrices = undefined;
	let latestForEachStation = undefined;
	let stationIdsWithoutLatestPrice = undefined;
	let maxStaleDays = '?';

	if (state.reportsGasBuddyPrices.latestGasBuddyPrices) {
		latestGasBuddyPrices = state.reportsGasBuddyPrices.latestGasBuddyPrices;
	}
	if (state.reportsGasBuddyPrices.latestIgnoredGasBuddyPrices) {
		latestIgnoredGasBuddyPrices = state.reportsGasBuddyPrices.latestIgnoredGasBuddyPrices;
	}

	if (state.reportsGasBuddyPrices.latestForEachStation) {
		latestForEachStation = state.reportsGasBuddyPrices.latestForEachStation;
	}

	if (state.reportsGasBuddyPrices.stationIdsWithoutLatestPrice) {
		stationIdsWithoutLatestPrice = state.reportsGasBuddyPrices.stationIdsWithoutLatestPrice;
		maxStaleDays = state.reportsGasBuddyPrices.maxStaleDays;
	}

	return {
		latestGasBuddyPrices,
		latestIgnoredGasBuddyPrices,
		latestForEachStation,
		stationIdsWithoutLatestPrice,
		maxStaleDays,
		stationMap: state.maps.station,
		authUser: state.auth.authUser,
		accessToken: state.auth.accessToken,
		gasBuddyPriceMap: state.maps.gasBuddyPrice,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			showErrors,
			getLatestGasBuddyPrices,
			getLatestLockedOutGasBuddyPrices,
			getRecentGasBuddyPrices,
			addGasBuddyPrice: add,
			updateGasBuddyPrice: update,
			bulkAddGasBuddyPrices: bulkAdd,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
